import { Observable, timer, Subscription, interval } from 'rxjs';

import { finalize, tap, switchMap } from 'rxjs/operators';
import { Component, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { PaginationDTO } from '../../api/PaginationModel';
import {
  TenderDTO,
  WorkProcurementCommitteeDTO,
  ProcurementCommitteeDTO,
  MemberProcurementCommitteeDTO,
  FileDetailsDTO,
  DocumentFileTypeDTO,
  DocumentDTO,
  ProcurementCommitteeState,
  getProcurementCommitteeStateValue,
  ProfileDTO,
  CipherMode,
  getSimpleIdentifierFromString,
  SignatureDTO,
  MemberTenderEvaluationCommitteeDTO,
  TenderStateDTO,
  TenderLotState,
  SignatureValidationCode
} from '../../api/plyca-dtos';

import { UIService } from '../../ui.service';
import { DossierService } from '../dossier.service';

import { TaskHandler } from '../../tasks/TaskHandler';
import { ProcurementProjectDTO, EnvelopeDTO, CompanyDTO } from '../../api/plyca-dtos-v2';
import { filePDFViewerComponent } from '../../documents/filePDFViewer/filePDFViewer.component';
import { decipherProcessComponent } from './decipherProcess.component';
import { tenderViewComponent } from '../tenderView/tenderView.component';
import { SignatureService } from '../../../services/signature.service';
import { TranslateService } from '@ngx-translate/core';
import { WaitLoadingService, LoadingInfo } from '../../components/common/waitLoading/wait-loading.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { MenuItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { SignatureProvider, SignatureProviderType, SignatureRequest, SignatureResponse, SignatureStatus } from '../../../services/signature/signature.objects';
import { SignatureUtils } from '../../../services/signature.utils';

class SignatureInfo {
  profile: ProfileDTO;
  name: string;
  identified: boolean;
  signature: SignatureDTO;
}

@Component({
  selector: 'tenderEvent',
  templateUrl: 'tenderEvent.template.html',
  providers: [DialogService]
})
export class tenderEventComponent extends TaskHandler
  implements OnInit, OnDestroy {
  tendersLoaded = false;
  //  membersLoaded = true;
  membersIdentified;
  modoIdentificacion = 'PLYCA'; // alternativa FRAGMENTOS

  MAX_LOADDOCUMENT_RETRIES = 3;
  RETRY_INTERVAL = 1500;

  private retryObservable: Observable<any>;
  private retrySubscription: Subscription;

  // INFORMACION DEL EXPEDIENTE
  dossier: ProcurementProjectDTO;
  dossierId: string;
  work: WorkProcurementCommitteeDTO;
  tenderList: any[] = [];

  steps: MenuItem[];

  // // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  // userPrefsSubs: Subscription;
  // userPrefs: UserPrefs;
  private filePDFViewerComponent: filePDFViewerComponent;
  currentFile: FileDetailsDTO;
  document: DocumentDTO;

  private docLoaded = false;
  public memberSignatures: Array<SignatureInfo>;

  colHeaders: string[];

  // Constantes
  CommitteeState = ProcurementCommitteeState;
  getProcurementCommitteeStateValue = getProcurementCommitteeStateValue;
  private envelopes: EnvelopeDTO[];

  private isSignModuleAvailable: Map<SignatureProviderType, boolean>;
  private enabledSignatureProviders: SignatureProvider[];


  @ViewChild(filePDFViewerComponent)
  set content(content: filePDFViewerComponent) {
    this.filePDFViewerComponent = content;
    if (
      this.filePDFViewerComponent &&
      this.filePDFViewerComponent.propsObservable instanceof Observable
    ) {
      this.subscribe(this.filePDFViewerComponent.propsObservable);
    }
  }

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    private signatureService: SignatureService,
    public dossierService: DossierService,
    public translateService: TranslateService,
    public waitService: WaitLoadingService,
    public headerActionsService: HeaderActionsService,
    public dialogService: DialogService,
    private plycaErrorHandler: PlycaErrorHandler,
    private signatureUtils: SignatureUtils
  ) {
    super();
    this.isSignModuleAvailable = new Map();
    this.enabledSignatureProviders = this.signatureUtils.getSignatureProviders().filter(provider =>
      this.signatureService.isSignatureProviderEnabled(provider.type)
    );
  }

  ngOnInit(): void {
    this.waitService.startWaiting();
    if (this.enabledSignatureProviders) {
      this.enabledSignatureProviders.forEach(provider => {
        this.signatureService.check(
          () => this.isSignModuleAvailable.set(provider.type, true),
          () => {
            this.isSignModuleAvailable.set(provider.type, false);
            this.uiService.showMessage(
              this.translateService.instant('Signature.Error.Connection', {
                nombreApp: this.translateService.instant(provider.config?.btnName)
              }),
              'Error', 'errorStyle',
              'General.accept');
          },
          provider.type
        );
      });
    }

    // this.loading.next(new LoadingInfo(true));
    this.dossier = this.task.division.project;
    this.work = this.task.work;
    this.envelopes = this.work.procurementCommitteeDTO.envelopes;
    // configuracion de pasos a seguir
    this.steps = [
      { label: 'Identificando usuarios' },
      //      { label: 'Quorum alcanzado' },
      { label: 'Descifrar sobres' },
      { label: 'Ofertas descifradas' }
      //      { label: 'Validando ofertas' },
      //      { label: 'Mesa completada' }
    ];
    this.colHeaders = [this.translateService.instant('TenderEvent.tenderTable.from'),
    this.translateService.instant('TenderEvent.tenderTable.register')];

    // en modo plyca, si estamos en el paso de identificar, inicializar el servicio de firma
    if (
      this.modoIdentificacion === 'PLYCA' &&
      getProcurementCommitteeStateValue(
        this.work.procurementCommitteeDTO.state
      ) <=
      getProcurementCommitteeStateValue(
        ProcurementCommitteeState.DECIPHER_IN_PROGRESS
      )
    ) {
      // configurar accion a ejecutar cada vez que se emite una firma pr parte de un miembro
      this.subscribe(this.signatureService.getSignatures(),
        (signature: SignatureResponse) => {
          if (signature.status === SignatureStatus.CANCELLED) {
            console.log('Seleccion de certificado de firma cancelada');
            this.waitService.cancelWaiting();
          } else if (signature.status === SignatureStatus.ERROR ||
            (signature.status === SignatureStatus.OK && signature.signatureStatus !== SignatureValidationCode.OK)
          ) {
            this.waitService.cancelWaiting();
            const invalidSignature = this.signatureUtils.getLastSignature(signature.file.signatures);
            if (invalidSignature) {
              this.signatureService.showSignatureValidationDetails(
                invalidSignature,
                signature.request.file
              );
            } else if (signature.errorMessage) {
              this.uiService.showMessage(signature.errorMessage);
            }
          } else {
            this.addSignature(signature);
          }
        });
    }

    // En modo plyca, la mesa tiene que tener documento de solicitud de apertura asociado. Si no, se genera.
    if (
      this.modoIdentificacion === 'PLYCA' &&
      !this.work.procurementCommitteeDTO.requestDocument
    ) {
      let cont = 1;
      this.retryObservable = interval(this.RETRY_INTERVAL).pipe(
        switchMap(() => this.plycaService.getProcurementCommittee(this.work.procurementCommitteeDTO.identifier)
          .pipe(
            tap((pCommite: ProcurementCommitteeDTO) => {
              cont++;
              this.work.procurementCommitteeDTO = pCommite;
              this.waitService.setLoadingInfo(
                new LoadingInfo(
                  true,
                  this.translateService.instant('DocumentView.wait.oe') +
                  ' - ' +
                  cont,
                  true
                )
              );
              if (this.work.procurementCommitteeDTO.requestDocument) {
                this.subscribe(this.reloadDocument(),
                  () => this.reloadTenders(true),
                  (error: any) => this.plycaErrorHandler.showServerError(error)
                );
              }
            })
          )
        )
      );
      this.subscribe(this.waitService.getLoadingObservable(),
        (loadingInfo: LoadingInfo) => {
          if (loadingInfo && !loadingInfo.loading) {
            this.stopRetrySubscription(loadingInfo.loading);
          }
        });

      this.subscribe(this.plycaService.generateRequestDocument(this.work.procurementCommitteeDTO),
        () => {
          // IMPORTANTE QUE LA SUBSCRIPCION SE HAGA DESPUES DE REGISTRAR EL OBSERVABLE DEL WAITSERVICE
          this.retrySubscription = this.retryObservable.subscribe();
        },
        (error: any) => this.plycaErrorHandler.showServerError(error)
      );
    } else {
      this.waitService.startWaiting();
      // this.loading.next(new LoadingInfo(true));
      this.subscribe(this.reloadDocument(),
        () => this.reloadTenders(true),
        (error: any) => this.plycaErrorHandler.showServerError(error)
      );
    }

    this.headerActionsService.clearActions();
    // Si la mesa esta en estado QUORUM_OK y existen ofertas a descifrar se puede lanzar el descifrado
    this.subscribe(this.headerActionsService.addAction(
      'TenderEvent.decipherAction',
      'fa fa-lg fa-angle-right',
      'btn-primary',
      function () {
        return (this.task.work.procurementCommitteeDTO.state === this.CommitteeState.QUORUM_OK && this.existsTendersToDecipher());
      }.bind(this)
    ),
      success => {
        this.decipher();
      });
    // Si la mesa esta en estado DECIPHERED, o QUORUM_OK y no hay ofertas se puede cerrar la mesa y despachar la tarea
    this.subscribe(this.headerActionsService.addAction(
      'TenderEvent.endEventAction',
      'fa fa-lg fa-stop',
      'btn-success',
      function () {
        return ((this.task.work.procurementCommitteeDTO.state === this.CommitteeState.DECIPHERED
          && this.allTendersReady()) ||
          (this.task.work.procurementCommitteeDTO.state === this.CommitteeState.QUORUM_OK && !this.existsTendersToDecipher())
        );
      }.bind(this)
    ),
      success => {
        this.closeEvent();
      });
    this.headerActionsService.addDivider();
    // firma con los distintos proveedores de seguridad registrados
    if (this.enabledSignatureProviders.length > 1) {
      this.headerActionsService.addActionGroup(
        'signature.actions',
        'TenderEvent.signDocument',
        'fa fa-lg fa-pencil',
        'btn-outline-primary',
        true
      );
      this.enabledSignatureProviders.forEach((provider: SignatureProvider) => {
        this.subscribe(this.headerActionsService.addActionToGroup(
          'signature.actions',
          provider.config?.btnName,
          provider.config?.btnIcon,
          provider.config?.btnClass,
          () => this.task.work.procurementCommitteeDTO.state === this.CommitteeState.OPENING_DOC_GENERATED ||
            this.task.work.procurementCommitteeDTO.state === this.CommitteeState.QUORUM_OK,
          undefined,
          () => this.isSignModuleAvailable.get(provider.type),
          'Signature.AutoFirma.ModuleNotLoaded'
        ).pipe(
          tap(() => this.signDocument(provider.type))
        ));
      });
    } else if (this.enabledSignatureProviders.length === 1) {
      const provider = this.enabledSignatureProviders[0];
      this.subscribe(this.headerActionsService.addAction(
        'TenderEvent.signDocument',
        provider.config?.btnIcon,
        provider.config?.btnClass,
        () => this.task.work.procurementCommitteeDTO.state === this.CommitteeState.OPENING_DOC_GENERATED ||
          this.task.work.procurementCommitteeDTO.state === this.CommitteeState.QUORUM_OK,
        () => this.isSignModuleAvailable.get(provider.type),
        'Signature.AutoFirma.ModuleNotLoaded'
      ).pipe(
        tap(() => this.signDocument(provider.type))
      ));
    }

    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ),
      success => {
        this.uiService.routeBack();
      });
  }

  private stopRetrySubscription(exit: boolean) {
    if (this.retrySubscription != null && !this.retrySubscription.closed) {
      this.retrySubscription.unsubscribe();
      if (exit) {
        this.validaCierreVentana = false;
        this.uiService.routeBack();
      }
    }
  }

  getActiveStep() {
    // 0 Identificando usuarios
    // 1 Quorum alcanzado
    // 2 Descifrando sobres
    // 3 Ofertas descifradas

    if (
      this.work.procurementCommitteeDTO.state ===
      ProcurementCommitteeState.INITIAL ||
      this.work.procurementCommitteeDTO.state ===
      ProcurementCommitteeState.OPENING_DOC_GENERATING ||
      this.work.procurementCommitteeDTO.state ===
      ProcurementCommitteeState.OPENING_DOC_GENERATED
    ) {
      return 0;
    } else if (
      this.work.procurementCommitteeDTO.state ===
      ProcurementCommitteeState.QUORUM_OK
    ) {
      return 1;
    } else if (
      this.work.procurementCommitteeDTO.state ===
      ProcurementCommitteeState.DECIPHER_IN_PROGRESS
    ) {
      return 2;
    } else {
      return 3;
    }
  }

  back() { }

  private reloadProcurementCommitee(): Observable<ProcurementCommitteeDTO> {
    return this.plycaService
      .getProcurementCommittee(this.work.procurementCommitteeDTO.identifier)
      .pipe(
        tap((pCommite: ProcurementCommitteeDTO) => {
          //        this.work.procurementCommitteeDTO.state = pCommite.state;
          this.work.procurementCommitteeDTO = pCommite;
        })
      );
  }

  private reloadDocument(): Observable<any> {
    return this.plycaService
      .getDocument(this.work.procurementCommitteeDTO.requestDocument.identifier)
      .pipe(
        tap((doc: DocumentDTO) => {
          let oe_files = this.documentService.getTypeDocument(
            DocumentFileTypeDTO.Original,
            doc
          );
          if (oe_files && oe_files.length > 0 && oe_files[0]) {
            this.currentFile = oe_files[0];
            let plainSignatures = new Array<SignatureDTO>();
            this.toPlainList(this.currentFile.signatures, plainSignatures);
            this.membersIdentified = plainSignatures.length;
            this.memberSignatures = new Array<SignatureInfo>();
            // mapear firmas con componentes. Las que no correspondan se incorporan como un nuevo componente.
            plainSignatures.forEach((signature: SignatureDTO) => {
              // let member: MemberProcurementCommitteeDTO = new MemberProcurementCommitteeDTO();
              // member.profile = new ProfileDTO();
              // member.profile.identifier = '-1';
              // member.profile.description = 'Otros';
              // member['description'] = signature.signer;
              // member.releasedFragment = true;
              // member.dateGenerationSecrets = signature.date;
              // this.work.procurementCommitteeDTO.members.push(member);
              let signatureInfo = new SignatureInfo();
              signatureInfo.name = signature.signer;
              signatureInfo.signature = signature;
              signatureInfo.identified = true;
              signatureInfo.profile = this.getProfileFromSignature(
                getSimpleIdentifierFromString(signature.identifier)
              );
              this.memberSignatures.push(signatureInfo);
            });
            // comprobar si se deben anyadir los componentes de la definicion de la mesa que no hayan firmado
            if (this.work.procurementCommitteeDTO.evaluationCommittee
              && this.work.procurementCommitteeDTO.evaluationCommittee.memberTenderEvaluationCommittee) {

              this.work.procurementCommitteeDTO.evaluationCommittee.memberTenderEvaluationCommittee
                .filter(
                  (definitionMember: MemberTenderEvaluationCommitteeDTO) =>
                    !this.work.procurementCommitteeDTO.members ||
                    !this.work.procurementCommitteeDTO.members.find(
                      (member: MemberProcurementCommitteeDTO) =>
                        member.user &&
                        member.user.identifier ===
                        definitionMember.user.identifier
                    )
                )
                .forEach((member: MemberTenderEvaluationCommitteeDTO) => {
                  let signatureInfo = new SignatureInfo();
                  signatureInfo.name = member.user.person.fullName;
                  signatureInfo.identified = false;
                  signatureInfo.profile = member.profile;
                  this.memberSignatures.push(signatureInfo);
                });
            }
            this.document = doc;
            this.docLoaded = true;
            this.stopRetrySubscription(false);
          } else {
            console.log(
              'NO ENCONTRADO ORIGINAL ELECTRÃNICO EN EL DOCUMENTO DE SOLICITUD DE APERTURA'
            );
          }
        })
      );
  }

  reloadTenders(openDecipher?: boolean) {
    this.subscribe(this.plycaService
      .getDossierTenders(this.dossier.identifier),
      (param: PaginationDTO<TenderDTO>) => {
        this.tenderList = param ? this.filterEventTenders(param.content, this.envelopes) : null;
        this.tendersLoaded = true;
        // una vez recuperada la informaciÃ³n, si el proceso de descifrado estÃ¡ lanzado abrimos el diÃ¡logo de espera
        if (
          this.work.procurementCommitteeDTO.state ===
          ProcurementCommitteeState.DECIPHER_IN_PROGRESS &&
          openDecipher
        ) {
          this.decipher();
        } else if (this.docLoaded) {
          this.waitService.cancelWaiting();
          // this.loading.next(new LoadingInfo(false));
        }
      });
  }

  private filterEventTenders(tenders: Array<TenderDTO>, envelopes: Array<EnvelopeDTO>): Array<TenderDTO> {
    let eventTenders: Array<TenderDTO>;
    if (tenders) {
      let openingEnvelopes = this.envelopes.map(openingEnvelope => openingEnvelope.identifier);
      // nos quedamos solo con las ofertas que han presentado algo para los sobres a descifrar
      eventTenders = tenders.filter(tender => tender.tenderEnvelopes)
        .filter(tender => tender.state !== TenderStateDTO.REJECTED && tender.state !== TenderStateDTO.CANCELLED)
        .filter(tender => tender.tenderEnvelopes.map(tenderEnvelope =>
          tenderEnvelope.envelope.identifier).find(tenderEnvelopeId =>
            openingEnvelopes.find(openingEnvelopeId => openingEnvelopeId === tenderEnvelopeId) !== undefined
          ) !== undefined)
        .filter(tender => {
          let validTender = true;
          // si hay lotes asegurarse que hay ofertas cuyos sobres estan asociados
          // al menos a un lote aceptado
          // aplanar identificadores de lotes asociados a sobres que se descifrarán
          if (tender.tendersLots) {
            if (tender.tendersLots.length !== 1 || getSimpleIdentifierFromString(tender.tendersLots[0].identifier) !== '0') {
              // Si oferta un solo lote y no es el lote cero
              // , o oferta a más de un lote
              let envelopeLotIds = [];
              envelopes.forEach(envelopeToOpen => {
                if (envelopeToOpen.lots) {
                  envelopeToOpen.lots.forEach(envelopeToOpenLot => envelopeLotIds.push(envelopeToOpenLot.lotId));
                }
                if (envelopeToOpen.lotGroups) {
                  envelopeToOpen.lotGroups.forEach(lotGroup => {
                    if (lotGroup.lots) {
                      lotGroup.lots.forEach(envelopeToOpenLot => envelopeLotIds.push(envelopeToOpenLot.lotId));
                    }
                  });
                }
              });
              validTender = tender.tendersLots.find(
                tenderLot => (tenderLot.state === TenderLotState.ADMITTED || tenderLot.state === TenderLotState.INITIAL) &&
                  // tslint:disable-next-line:triple-equals
                  envelopeLotIds.find(lotId => getSimpleIdentifierFromString(tenderLot.identifier) == lotId)) !== undefined;
            }
          }
          return validTender;
        })
    }
    return eventTenders;
  }

  // para que funcione:
  // 1. comp es el componente modal a abrir.
  // 2. comp debe estar en los entrycomponents del modulo del componente que invoque
  openTender(tender: TenderDTO) {
    let config: DynamicDialogConfig = {
      header: 'Información de la oferta',
      width: '70%',
      style: { overflow: 'hidden', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    config['dossier'] = this.dossier;
    config['tenderId'] = tender.identifier;
    const ref = this.dialogService.open(tenderViewComponent, config);
  }

  identifyMember() {
    // let modal: any = ServiceLocator.injector.get(Modal);
    // let context = new DossierDTOModal(this.dossier);
    // context['tenderprocurementCommitteeDTOId'] = this.work.identifier;
    // let val = member.identifier;
    // // 10.8 Workarround solucionar el problema del id compuesto de los MasterData
    // if (typeof val === 'string' && val.indexOf('<>') != -1) {
    //   val = val.substring(0, val.indexOf('<>'));
    // }
    // console.log('member', val);
    // //    context['memberId'] = member.identifier;
    // context['memberId'] = val;
    // context['certificate'] = member.certificatePerson.certificate;
    // context.isBlocking = true;
    // let mod = modal.open(
    //   tenderEventProcessComponent,
    //   overlayConfigFactory(context)
    // );
    // if (mod.result) {
    //   mod.result.then(
    //     () => {
    //       console.log('Usuario identificado: ' + member.identifier);
    //       // actualizamos mesa por si se ha producido un cambio de estado
    //       this.reloadProcurementCommitee();
    //       this.reloadMembers();
    //     },
    //     () => {
    //       console.log('Cancelado!!!' + member.identifier);
    //       // actualizamos mesa por si se ha producido un cambio de estado
    //       this.reloadProcurementCommitee();
    //       this.reloadMembers();
    //     }
    //   );
    // }
  }

  isMemberIdentifierd(identifier) {
    let identified = false;
    if (identifier) {
      let m = this.task.work.procurementCommitteeDTO.members.filter(
        member => member.user && member.user.identifier === identifier
      );
      if (m.length === 1) {
        if (
          this.work.procurementCommitteeDTO.phase.cipherMode ===
          CipherMode.SECRETO_COMPARTIDO
        ) {
          identified = m[0].releasedFragment;
        } else {
          identified = true;
        }
      }
    }
    return identified;
  }

  getMemberInfo(identifier, jsonPath: string) {
    let ret;
    let m = this.task.work.procurementCommitteeDTO.members.filter(
      member => member.identifier === identifier
    );
    if (m.length === 1) {
      ret = m[0][jsonPath];
      if (ret === undefined) {
        ret = '';
      }
    }
    return ret;
  }

  private decipher() {
    let config: DynamicDialogConfig = {
      header: this.translateService.instant(
        'TenderEvent.TitleDecipherTenderProcess'
      ),
      width: '60%',
      style: { overflow: 'scroll', 'max-height': '60%' },
      styleClass: 'helpStyle'
    };
    config[
      'tenderprocurementCommitteeDTOId'
    ] = this.work.procurementCommitteeDTO.identifier;
    config['tenderprocurementCommitteeDTO'] = this.work;
    config['envelopes'] = this.envelopes;
    config['dossier'] = this.dossier;
    const ref = this.dialogService.open(decipherProcessComponent, config);
    this.subscribe(ref.onClose,
      result => {
        if (result) {
          console.log('Ofertas descifradas');
          this.waitService.startWaiting();
          this.subscribe(timer(2500)
            .pipe(
              switchMap(() => this.reloadProcurementCommitee()),
              finalize(() => this.waitService.cancelWaiting()))
          );
        } else {
          console.log('Cancelado!!! descifrar ofertas');
        }
      });
  }

  seeAllActive() {
    let resp = true;
    // if (tender && tender.tenderEnvelopes) {
    //   // filtrar solo para el sobre activo
    //   let envelope: TenderEnvelopeDTO = tender.tenderEnvelopes.find(
    //     tenderEnvelope =>
    //       tenderEnvelope.envelopeType.identifier ===
    //       this.work.envelopeType.identifier
    //   );
    //   if (envelope) {
    //     resp = resp && envelope.seeAll;
    //   }
    // } else {
    //   resp = false;
    // }
    return resp;
  }

  private allTendersReady() {
    let resp = true;
    this.tenderList.forEach(() => {
      resp = resp && this.seeAllActive();
    });
    return resp;
  }

  public existsTendersToDecipher(): boolean {
    return this.tenderList && this.tenderList.length > 0;
  }

  closeEvent() {
    this.processTask();
  }

  ngOnDestroy(): void {
    if (this.retrySubscription && !this.retrySubscription.closed) {
      this.retrySubscription.unsubscribe();
    }
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  isLoaded(): boolean {
    return this.tendersLoaded && this.docLoaded;
  }

  // public isLoading(): Observable<LoadingInfo | boolean> {
  //   return this.loadingObservable;
  // }

  signDocument(type: SignatureProviderType) {
    console.log('firmando documento');
    if (this.currentFile) {
      this.waitService.startWaiting();
      const request = new SignatureRequest;
      request.file = this.currentFile;
      request.documentClass = this.document.entity.documentClass;
      request.provider = type;
      this.signatureService.sign(request);
    }
  }

  private addSignature(signature: SignatureResponse) {
    console.log(signature);
    if (signature.signatureStatus === SignatureValidationCode.OK) {
      this.subscribe(this.plycaService
        .updateRequestDocument(
          this.work.procurementCommitteeDTO.identifier,
          signature.file.identifier
        ),
        () => {
          this.subscribe(this.reloadProcurementCommitee(),
            () => {
              if (
                this.work.procurementCommitteeDTO.phase.cipherMode ===
                CipherMode.CUSTODIO_PLYCA
              ) {
                this.subscribe(this.reloadDocument(), () => this.waitService.cancelWaiting())
              } else {
                this.waitService.cancelWaiting();
              }
            });
        },
        (error: any) => this.plycaErrorHandler.showServerError(error)
      );
    } else {
      this.waitService.cancelWaiting();
    }
  }

  private toPlainList(
    signatures: SignatureDTO[],
    plainSignatureList: Array<SignatureDTO>
  ): void {
    if (signatures) {
      signatures.forEach((signature: SignatureDTO) => {
        console.log('Firma ' + signature.signer);
        plainSignatureList.push(signature);
        this.toPlainList(signature.signatures, plainSignatureList);
      });
    }
  }

  private handleError(error: any, salirSinValidar = false): void {
    if (salirSinValidar) {
      if (this.retrySubscription) {
        this.retrySubscription.unsubscribe();
      }
      this.validaCierreVentana = false;
    }
    this.waitService.cancelWaiting();
    // this.loading.next(new LoadingInfo(false));
    this.plycaErrorHandler.showServerError(error);
  }

  public validateSignature(signature: SignatureDTO): void {
    if (signature) {
      this.documentService.validateSignDocument(signature, this.currentFile);
    }
  }

  private getProfileFromSignature(identifier: string): ProfileDTO {
    let profile: ProfileDTO;
    let member = this.task.work.procurementCommitteeDTO.members.find(
      committeeMember =>
        committeeMember.signature &&
        getSimpleIdentifierFromString(committeeMember.signature.identifier) ===
        identifier
    );
    if (member && member.profile) {
      profile = member.profile;
    } else {
      profile = new ProfileDTO();
      profile.identifier = '99999';
      profile.description = this.translateService.instant(
        'TenderEvent.noProfile'
      );
      profile.name = profile.description;
    }
    return profile;
  }

  public getCompanyDescription(company: CompanyDTO): string {
    return CompanyDTO.getCompanyDescription(company);
  }
}
